__turbopack_context__.v({
  "accountsSection": "PublicationsTab-module__kIAFFq__accountsSection",
  "contentSection": "PublicationsTab-module__kIAFFq__contentSection",
  "publicationsSection": "PublicationsTab-module__kIAFFq__publicationsSection",
  "sectionHeader": "PublicationsTab-module__kIAFFq__sectionHeader",
  "socialLink": "PublicationsTab-module__kIAFFq__socialLink",
  "socialLinksContainer": "PublicationsTab-module__kIAFFq__socialLinksContainer",
});
